import { render, staticRenderFns } from "./Food.vue?vue&type=template&id=7d38fd4f&scoped=true&"
var script = {}
import style0 from "./Food.vue?vue&type=style&index=0&id=7d38fd4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d38fd4f",
  null
  
)

export default component.exports